import React from 'react';
import isNil from 'lodash/isNil';
import CoachingPageContainer from 'components/coaching/CoachingPageContainer';
import AdminDashCoaching from 'components/dashboard/admin/AdminDashCoaching';
import {loadUpcomingReviewData} from 'components/dashboard/UpcomingCoachingAgenda';
import {getQueryParam} from 'utils/getQueryParam';

/**
 * This class is a simple wrapper around AdminDashCoaching so that
 * we can reuse the space meant for AdminDashCoaching to show a coaching plan instead
 */
export default class AdminDashCoachingWrapper extends React.Component {
  render() {
    const planId = getQueryParam(this.props.location, 'planId');
    if (isNil(planId)) {
      return <AdminDashCoaching {...this.props} />;
    } else {
      return (
        <CoachingPageContainer
          {...this.props}
          refreshUpcomingReviews={() =>
            loadUpcomingReviewData(this.props.adminId, this.props.coachId)
          }
        />
      );
    }
  }
}
